import { AbstractBlock } from '../AbstractBlock';
import { CodeSetting } from '../setting/CodeSetting';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
const Blockly = GlobalImport.getBlockly();

export class AbstractOperator extends AbstractBlock {
  RIGHT = 'RIGHT';

  LEFT = 'LEFT';

  CALC = 'CALC';

  defineBlock(block: BlockType): void {
    ColorSettings.setOperatorColor(block);
    ShapeSettings.setOperatorBoolShape(block);

    // フィールド
    const calc = this.getCalculatorField();

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(new Blockly.FieldTextInput('10'), this.LEFT)
      .appendField(calc, this.CALC)
      .appendField(new Blockly.FieldTextInput('10'), this.RIGHT);
  }

  getCalculatorCode(block: BlockType): string {
    return CodeSetting.getFieldValue(block, this.CALC);
  }

  getCalculatorField(): string {
    // override
    return null;
  }

  codeGenerateCore(block: BlockType): string[] {
    const left = CodeSetting.getFieldValueWithoutEncode(block, this.LEFT);
    const right = CodeSetting.getFieldValueWithoutEncode(block, this.RIGHT);
    const calculator = this.getCalculatorCode(block);
    // let str = "{{ " + left + " " + calcurator + " " + right + " }}";
    const str = ` ${left} ${calculator} ${right} `;
    return [str];
  }
}
